import { useAuthStore, User } from "@store/auth.store";

class AuthStorageService {
  private static instance = new AuthStorageService();
  constructor() {
    if (AuthStorageService.instance) {
      return AuthStorageService.instance;
    }
  }

  get(): User | null {
    return useAuthStore.getState().user;
  }
}

export const authStorageService = Object.freeze(new AuthStorageService());
